<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content" v-loading="loadingStaus" :element-loading-text="loadingText">
				<el-row :gutter="48">
					<el-form ref="companyForm" :disabled="formDisabled" :model="formData" :rules="rules" label-width="120px">
						<el-col :span="18">
							<el-form-item v-for="item in list" :label="item.name" :prop="item.props" :key="item.props">
								<el-input v-model="formData[item.props]"></el-input>
							</el-form-item>
							<el-form-item label="申报状态" prop="declare_status">
								<el-input :value="declareStatusTypeList[formData.declare_status]"></el-input>
							</el-form-item>
							<el-form-item label="缴纳状态" prop="pay_status">
								<el-input :value="payStatusTypeList[formData.pay_status]"></el-input>
							</el-form-item>
							<el-form-item label="申报时间" prop="declare_time">
								<el-input v-model="formData.declare_time"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import UploadFile from '@/components/UploadFile';
import uploadImg from '@/components/uploadImg';
import { mapGetters } from 'vuex';
const declareStatusTypeList = ['待申报', '申报中', '申报成功', '申报失败'];
const payStatusTypeList = ['待缴纳', '已缴纳'];
export default {
	components: {
		PageHeaderLayout,
		UploadFile,
		uploadImg
	},
	data() {
		return {
			query: {},
			loadingStaus: false,
			loadingText: '正在提交中……',
			formDisabled: true,
			areaList: [],
			isShowPassword: false,
payStatusTypeList,
			declareStatusTypeList,
			detail: {},
			formData: {},
			list: [
				{ name: '服务商名称', props: 'channel_name' },
				{ name: '公司名称', props: 'company_name' },
				{ name: '下发通道', props: 'yl_bank_name' },
				{ name: '服务类型', props: 'category_name' },
				{ name: '结算金额', props: 'money' },
				{ name: '个税', props: 'accumulate_tax_money' },
				{ name: '增值税', props: 'added_tax_money' }
			],
			rules: {}
		};
	},
	computed: {
		...mapGetters(['userPermissions'])
	},
	methods: {
		// 确认保存按钮
		async saveConfirm() {
			// 调用组件的数据验证方法
			this.$refs['companyForm'].validate((valid) => {
				if (valid) {
					this.formSubmit();
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！');
				}
			});
			return true;
		},

		//查询信息
		async get_info() {
			const data = await this.$api.get_qxy_declare_tax_declare_view({
				id: this.query.id,
				type: 'company'
			});
			
			this.formData = this.detail = data;

			console.log(data);
		},
		// 初始化公司基本信息
		async init() {
			this.loadingStaus = false;
		}
	},
	async mounted() {
		this.query = this.$route.query;
		this.get_info();
		this.init();
	}
};
</script>

<style lang="scss" scoped>
.password-box {
	padding-left: 90px;
	margin-top: 24px;
}
::v-deep .el-select {
	width: 100%;
}
</style>
